import React from 'react';
import { motion } from 'framer-motion';
import { Search, Target, Zap, Settings } from 'lucide-react';
export function MethodSection() {
  const steps = [{
    icon: Search,
    title: 'Identificar',
    desc: 'Tus habilidades monetizables ocultas.'
  }, {
    icon: Target,
    title: 'Definir',
    desc: 'Una oferta mínima viable irresistible.'
  }, {
    icon: Zap,
    title: 'Ejecutar',
    desc: 'Lanzamiento rápido en solo 7 días.'
  }, {
    icon: Settings,
    title: 'Ajustar',
    desc: 'Optimizar según los primeros resultados.'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-brand-dark text-white relative overflow-hidden" data-id="element-80">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-5" data-id="element-81">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-82"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-84">
          <h2 className="font-heading text-3xl md:text-5xl font-bold mb-6" data-id="element-85">
            El Método <span className="text-brand-accent" data-id="element-86">“IDEA Rápida”</span>
          </h2>
          <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed" data-id="element-87">
            Este sistema te guía paso a paso. Este enfoque ha sido diseñado para
            personas reales con responsabilidades, y es flexible y práctico.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-88">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative" data-id="element-89">
              <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 p-8 rounded-2xl h-full flex flex-col items-center text-center hover:border-brand-accent/50 transition-colors" data-id="element-90">
                <div className="w-16 h-16 bg-brand-accent/10 rounded-full flex items-center justify-center mb-6" data-id="element-91">
                  <step.icon className="w-8 h-8 text-brand-accent" data-id="element-92" />
                </div>
                <h3 className="font-heading text-2xl font-bold mb-3" data-id="element-93">
                  {step.title}
                </h3>
                <p className="text-slate-400" data-id="element-94">{step.desc}</p>
              </div>

              {/* Connector line for desktop */}
              {index < steps.length - 1 && <div className="hidden lg:block absolute top-1/2 -right-4 w-8 border-t-2 border-dashed border-slate-600 z-0" data-id="element-95"></div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}